import React, { useEffect, useState, useRef } from "react";
import { List, Datagrid, FunctionField, useRedirect, useDataProvider, useListContext, SearchInput, TopToolbar, CreateButton, useResourceContext } from "react-admin";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";
import { Card, CardContent, Button, Box } from "@mui/material";
import { getCustomerTypeName, getResource } from "../common";
import CustomCreateButton from "../components/CustomeCreateButton";
import FilterableHeaderWithPopover from "./FilterableHeaderWithPopover";
import { InitialFilterTabs } from "../components/InitialFilterTabs";

const CustomersAllList = () => {
  const redirect = useRedirect();
  const location = useLocation();
  const resource = useResourceContext(); 
  const searchParams = new URLSearchParams(location.search);
  const dataProvider = useDataProvider();
  const navigate = useNavigate();

  const [filterType, setFilterType] = useState(null);
  const [filterCity, setFilterCity] = useState(null);
  const [filterTown, setFilterTown] = useState(null);
  const [page, setPage] = useState(filterType ? (filterCity ? (filterTown ? 3 : 2) : 1) : 0);
  const [addressData, setAddressData] = useState([]);
  const [serchText, setSearchText] = useState(null);
  const [isTop, setIsTop] = useState();
  const [hasSearched, setHasSearched] = useState(false);

  const prevFilterType = useRef(filterType);
  const prevFilterCity = useRef(filterCity);
  const prevFilterTown = useRef(filterTown);

  useEffect(() => {
    if (searchParams && searchParams.get("customer")) {
      setFilterType(searchParams.get("customer"));
      if (searchParams.get("town")) {
        setFilterTown(searchParams.get("town"))
        setPage(3);
      }
      else if (searchParams.get("city")) {
        setFilterCity(searchParams.get("city"))
        setPage(2);
      }
      else {
        setPage(1);
      }

    }
  }, []);

  const onSearch = (value) => {
    setSearchText(value);
    setHasSearched(true);
  }


  const CustomerFilters = [
    <SearchInput
      source="q"
      alwaysOn
      // placeholder="郵便番号・住所・顧客名・オーナー名"
      inputProps={{ style: { fontSize: '12px' } }}
      sx={{ width: 250 }}
      onChange={onSearch}
      value={serchText}
    />,
  ];

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/customers"/>
    </TopToolbar>
  );

  const handleClick = (type) => {
    // console.log(page)
    // console.log(type);
    // if (page === 0) {
    //   searchParams.set("customer", type);
    //   redirect(`?${searchParams.toString()}`);
    //   setFilterType(type);
    //   setPage(1);
    // } else if (page === 1) {
    //   searchParams.set("city", type);
    //   redirect(`?${searchParams.toString()}`);
    //   setFilterCity(type);
    //   setPage(2);
    // } else if (page === 2) {
    //   searchParams.set("town", type);
    //   redirect(`?${searchParams.toString()}`);
    //   setFilterTown(type);
    //   setPage(3);
    // }
    navigate(type)
  };

  const getCustomerWithType = async (filterType) => {
    try {
      const response = await dataProvider.getList("customers", {
        pagination: {
          page: searchParams.get("page") ? parseInt(searchParams.get("page"), 10) : 1,
          perPage: searchParams.get("perPage") ? parseInt(searchParams.get("perPage"), 10) : 10,
        },
        sort: {
          field: searchParams.get("sort") || "id",
          order: searchParams.get("order") || "ASC",
        },
        filter: searchParams.get("filter") ? JSON.parse(searchParams.get("filter")) : {},
        customer: filterType
      });

      setUniqueCitiesWithoutHouseNumbers(response.data);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };


  const setUniqueCitiesWithoutHouseNumbers = (customers) => {
    const citySet = new Set();

    customers.forEach(({ address }) => {
      if (!address) return;

      let cityName = '';

      const prefecturePattern = /^(.*?[都道府県])/;
      const addressWithoutPref = address.replace(prefecturePattern, '');
      if (page === 1) {
        const match = addressWithoutPref.match(/^(.+?[市区])/);
        if (match) {
          cityName = match[1].trim();
        }
      } else if (page === 2) {
        // 市 or 区以降〜数字が現れる前まで
        const match = addressWithoutPref.match(/[市区](.*?)(?=\d|丁目|番地|号|$)/);
        if (match) {
          cityName = match[1].trim();
        }
      }
      if (cityName) {
        citySet.add(cityName);
      }
    });

    setAddressData(Array.from(citySet));
  };


  const handleBackToTop = () => {
    setIsTop(true);
    setSearchText(null);
  };

  return (
    <>
    {hasSearched && <Button onClick={handleBackToTop} variant="contained" style={{ marginTop: "10px", width: "150px" }}>検索TOPに戻る</Button>}
    <List actions={<CustomersActions />} filters={CustomerFilters}>
    {!hasSearched ? (
      <div style={{ padding: "30px 20px", margin: "0 10px 50px" }}>
          <CardContent>
            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "40px",
              textAlign: "center"
            }}>
              <Button onClick={() => handleClick("/customers-clean")} style={buttonStyle}><h3>浄化槽清掃</h3></Button>
              <Button onClick={() => handleClick("/customers-inspect")} style={buttonStyle}><h3>浄化槽点検</h3></Button>
              <Button onClick={() => handleClick("/customers-construct")} style={buttonStyle}><h3>浄化槽修理</h3></Button>
              <Button onClick={() => handleClick("/customers-garbage-commit")} style={buttonStyle}><h3>ごみ収集委託</h3></Button>
              <Button onClick={() => handleClick("/customers-garbage-allow")} style={buttonStyle}><h3>ごみ収集許可</h3></Button>
              <Button onClick={() => handleClick("/customers-waste")} style={buttonStyle}><h3>し尿</h3></Button>
            </div>
          </CardContent>
        </div>
    ) : (
      <>
        <ListComponent 
          filterType={filterType} 
          prevFilterType={prevFilterType} 
          filterTown={filterTown} 
          prevFilterTown={prevFilterTown} 
          filterCity={filterCity} 
          prevFilterCity={prevFilterCity} 
          getCustomerWithType={getCustomerWithType} 
          navigate={navigate}
          isTop={isTop}
          setSearchText={setSearchText}
          setHasSearched={setHasSearched}
          setIsTop={setIsTop}
        />
      </>
    )}
    </List>
    </>

  );
};
      {/* {page === 3 && <Button onClick={() => { window.location.href = "/customer" }} variant="contained" style={{ marginTop: "10px", width: "150px" }}>初めに戻る</Button>}
      <div style={{ display: 'flex', width: '100%' }}>
        {(page <= 2 && page > 0 || (page === 0 && serchText)) && (
          <div style={{ width: '50%' }}>
            <Button onClick={() => { window.location.href = "/customer" }} variant="contained" style={{ margin: "18px 10px 10px" }}>初めに戻る</Button>
            <Card sx={{ padding: "30px 20px", margin: "0 10px 50px" }}>
              <CardContent>
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "40px",
                  textAlign: "center"
                }}>
                  {page === 0 ? (
                    <>
                      <Button onClick={() => handleClick("/customers-clean")} style={buttonStyle}><h3>浄化槽清掃</h3></Button>
                      <Button onClick={() => handleClick("isInspectCus")} style={buttonStyle}><h3>浄化槽点検</h3></Button>
                      <Button onClick={() => handleClick("isConstructCus")} style={buttonStyle}><h3>浄化槽修理</h3></Button>
                      <Button onClick={() => handleClick("isGarbageCommitCus")} style={buttonStyle}><h3>ごみ収集委託</h3></Button>
                      <Button onClick={() => handleClick("isGarbageAllowCus")} style={buttonStyle}><h3>ごみ収集許可</h3></Button>
                      <Button onClick={() => handleClick("isWasteCus")} style={buttonStyle}><h3>し尿</h3></Button>
                    </>
                  ) : (
                    addressData.map((data) => (
                      <Button key={data} onClick={() => handleClick(data)} style={buttonStyle}>
                        <h3>{data}</h3>
                      </Button>
                    ))
                  )}
                </div>
              </CardContent>
            </Card>
          </div>

        )}
        <div style={((page <= 2 && page > 0) || (page === 0 && serchText))  ? { width: '50%' } : { width: '100%' }}>
          <List actions={<CustomersActions />} filters={CustomerFilters}>
            {(page === 0 && !serchText) ? (
              <div style={{ padding: "30px 20px", margin: "0 10px 50px" }}>
                <CardContent>
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "40px",
                    textAlign: "center"
                  }}>
                    <Button onClick={() => handleClick("/customers-clean")} style={buttonStyle}><h3>浄化槽清掃</h3></Button>
                    <Button onClick={() => handleClick("isInspectCus")} style={buttonStyle}><h3>浄化槽点検</h3></Button>
                    <Button onClick={() => handleClick("isConstructCus")} style={buttonStyle}><h3>浄化槽修理</h3></Button>
                    <Button onClick={() => handleClick("isGarbageCommitCus")} style={buttonStyle}><h3>ごみ収集委託</h3></Button>
                    <Button onClick={() => handleClick("isGarbageAllowCus")} style={buttonStyle}><h3>ごみ収集許可</h3></Button>
                    <Button onClick={() => handleClick("isWasteCus")} style={buttonStyle}><h3>し尿</h3></Button>
                  </div>
                </CardContent>
              </div>
            ) : (
              <ListComponent filterType={filterType} prevFilterType={prevFilterType} filterTown={filterTown} prevFilterTown={prevFilterTown} filterCity={filterCity} prevFilterCity={prevFilterCity} getCustomerWithType={getCustomerWithType} navigate={navigate}/>
            )}
          </List>
        </div>
      </div>

    </> */}
const ListComponent = ({ filterType, prevFilterType, filterCity, prevFilterCity, filterTown, prevFilterTown, getCustomerWithType, navigate, isTop, setSearchText, setHasSearched, setIsTop}) => {
  const { refetch, setFilters, filterValues } = useListContext();

  const resetFilter = () => {
    // 第1引数: filters オブジェクトを空に
    // 第2引数: displayedFilters オブジェクトを空に
    setFilters({}, {});
    setSearchText(null);
  };

  useEffect(() => {
    if (isTop) { 
      setFilters({}, {});
      setIsTop(false);
      setHasSearched(false);
    }
  }, [isTop]);

  useEffect(() => {
    if (filterType && prevFilterType.current !== filterType) {
      getCustomerWithType(filterType);
      prevFilterType.current = filterType;
      refetch();
    }
    if (filterCity && prevFilterCity.current !== filterCity) {
      prevFilterCity.current = filterCity;
      getCustomerWithType(filterType);
      console.log(filterCity)
      refetch();
    }
    if (filterTown && prevFilterTown.current !== filterTown) {
      prevFilterTown.current = filterTown;
      console.log(filterTown)
      refetch();
    }
  }, [filterType, filterCity, filterTown]);

    const handleRowClick = (id, basePath, record) => {
      const url = `${window.location.origin}/#/${getResource(record)}/show/${record.customerId}`;
      const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
      window.open(url, '_blank', features);
      return false;
    };

  return (
    // <Datagrid 
    //   rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)}
    //   bulkActionButtons={false}
    // >
    //   <FunctionField label={<FilterableHeaderWithPopover source="bukken" label="物件名(カナ)" />}
    //     render={record => {
    //       return `${record.bukken ?? ""}(${record.bukken_k ?? ""})`;
    //     }}
    //   />
    //   <FunctionField label="顧客名" render={record => `${record.surname ?? ""} ${record.name ?? ""}`} />
    //   {/* <FunctionField label="会社名" render={record => `${record.companyName ?? ""}`} /> */}
    //   {/* <FunctionField label="電話番号" render={record => `${record.phone ? record.phone : record.telephone ? record.telephone : ""}`} /> */}
    //   <FunctionField
    //     source="phone"
    //     label="電話番号１"
    //     render={(record) => record.phone ?? ""}
    //   />
    //   <FunctionField
    //     source="telephone"
    //     label="電話番号２"
    //     render={(record) => record.telephone ?? ""}
    //   />
    //   <FunctionField label="住所" render={record => `${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`} />
      // <FunctionField
      //   label="顧客タイプ"
      //   render={record => {
      //     return (
      //       <>
      //         {
      //           (getCustomerTypeName({
      //             isCleanCus: record.isCleanCus,
      //             isInspectCus: record.isInspectCus,
      //             isConstructCus: record.isConstructCus,
      //             isGarbageCommitCus: record.isGarbageCommitCus,
      //             isGarbageAllowCus: record.isGarbageAllowCus,
      //             isWasteCus: record.isWasteCus
      //           })).join("・")
      //         }
      //       </>
      //     );
      //   }}
      // />
      // <FunctionField label="契約オーナー名" render={record => `${record.orner_surname ?? ""} ${record.orner_name ?? ""}`} />
    // </Datagrid>
    <>
    <Button onClick={resetFilter}>
      フィルターをリセット
    </Button>
    <Box sx={{ display: 'flex', width: '100%' }}>
      {/* 左側：あかさタブ */}
      <Box component="nav">
        <InitialFilterTabs />
      </Box>

      {/* 右側：Datagrid は flex:1 で残り幅を占有 */}
      <Box sx={{ flex: 1 }}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} >
        <FunctionField label={<FilterableHeaderWithPopover source="bukken" label="物件名" />}
          render={record => {
            return `${record.bukken ?? ""}`;
          }}
        />
        <FunctionField
          label={<FilterableHeaderWithPopover source="surname" label="顧客名" />}
          render={record => {
            return `${record.surname ?? ""} ${record.name ?? ""}`;
          }}
        />
        {/* <TextField source="companyName" label="会社名" /> */}
        <FunctionField
          source="phone"
          label={<FilterableHeaderWithPopover source="phone" label="電話番号１" />}
          render={(record) => record.phone ?? ""}
          sortable={false}
        />
        <FunctionField
          source="telephone"
          label={<FilterableHeaderWithPopover source="telephone" label="電話番号２" />}
          render={(record) => record.telephone ?? ""}
          sortable={false}
        />
        <FunctionField
          source="fax"
          label={<FilterableHeaderWithPopover source="fax" label="FAX" />}
          render={(record) => record.fax ?? ""}
          sortable={false}
        />
        <FunctionField
          label={<FilterableHeaderWithPopover source="address" label="住所" />}
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField
          label={<FilterableHeaderWithPopover source="orner_surname" label="オーナー名" />}
          render={record => {
            return `${record.orner_surname ?? ""} ${record.orner_name ?? ""}`;
          }}
        />
        <FunctionField
          label="顧客タイプ"
          render={record => {
            return (
              <>
                {
                  (getCustomerTypeName({
                    isCleanCus: record.isCleanCus,
                    isInspectCus: record.isInspectCus,
                    isConstructCus: record.isConstructCus,
                    isGarbageCommitCus: record.isGarbageCommitCus,
                    isGarbageAllowCus: record.isGarbageAllowCus,
                    isWasteCus: record.isWasteCus
                  })).join("・")
                }
              </>
            );
          }}
        />
      </Datagrid>
      </Box>
      </Box>
      </>
  );
};

const buttonStyle = {
  padding: "0 30px",
  backgroundColor: "#ddd",
  borderRadius: "10px",
  textAlign: "center",
};

export default CustomersAllList;